// costants
import { TABS } from "../../constants/index";

export interface MenuItemType {
  id: number;
  key: string;
  icon: string;
  tooltipTitle: string;
  className?: string;
  tabId:
    | TABS.BOOKMARK
    | TABS.CALLS
    | TABS.CHAT
    | TABS.ROBOT
    | TABS.CONTACTS
    | TABS.SETTINGS
    | TABS.TEMPLATES
    | TABS.USERS;
}
const MENU_ITEMS: MenuItemType[] = [
  {
    id: 1,
    key: "pills-user-tab",
    icon: "bx bx-user-circle",
    tooltipTitle: "Perfil",
    className: "d-none d-lg-block",
    tabId: TABS.USERS,
  },

  {
    id: 3,
    key: "pills-contacts-tab",
    icon: "bx bxs-user-detail",
    tooltipTitle: "Contatos",
    tabId: TABS.CONTACTS,
  },

  {
    id: 2,
    key: "pills-chat-tab",
    icon: "bx bx-conversation",
    tooltipTitle: "Mensagens",
    tabId: TABS.CHAT,
  },

  {
    id: 4,
    key: "pills-bot-tab",
    icon: "bx bx-bot",
    tooltipTitle: "Agente Virtual",
    tabId: TABS.ROBOT,
  },

  // {
  //   id: 5,
  //   key: "pills-calls-tab",
  //   icon: "bx bx-phone-call",
  //   tooltipTitle: "Calls",
  //   tabId: TABS.CALLS,
  // },

  // {
  //   id: 5,
  //   key: "pills-bookmark-tab",
  //   icon: "bx bx-bookmarks",
  //   tooltipTitle: "Bookmark",
  //   tabId: TABS.BOOKMARK,
  // },

  // {
  //   id: 7,
  //   key: "pills-templates-tab",
  //   icon: "bx bx-file",
  //   tooltipTitle: "Template",
  //   tabId: TABS.TEMPLATES,
  // },

  {
    id: 6,
    key: "pills-setting-tab",
    icon: "bx bx-cog",
    tooltipTitle: "Configuração",
    tabId: TABS.SETTINGS,
  },
];

export { MENU_ITEMS };
